import { render } from "./BlogTravel1.vue?vue&type=template&id=f0fd8de0&scoped=true"
import script from "./BlogTravel1.vue?vue&type=script&lang=js"
export * from "./BlogTravel1.vue?vue&type=script&lang=js"

import "./BlogTravel1.vue?vue&type=style&index=0&id=f0fd8de0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fd8de0"]])

export default __exports__